<template>
  <div class="verify-notice">
    <TopBarBackTitle
      class="top-bar-title"
      :partners-key="partnersKey"
    >
      <template #right>
        <div
          class="point-cursor"
          @click="changeLanguage"
        >
          {{ selectedLanguage === 'English' ? '한글' : 'English' }}
        </div>
      </template>
    </TopBarBackTitle>
    <component
      :is="componentId"
      @move-to-supera="moveToSupera"
      @move-to-channel-home="moveToChannelHome"
    ></component>
  </div>
</template>

<script setup lang="ts">
import MainNoticeDetailKo from '@/components/templates/main/MainNoticeDetailKo.vue'
import MainNoticeDetailEn from '@/components/templates/main/MainNoticeDetailEn.vue'

definePageMeta({
  layout: 'center'
})

const route = useRoute()
const partnersKey = String(route.params.partner || '')

const selectedLanguage = ref<'English' | '한글'>('한글')
const changeLanguage = () => {
  selectedLanguage.value = selectedLanguage.value === 'English' ? '한글' : 'English'
}
const componentId = computed(() =>
  selectedLanguage.value === 'English' ? MainNoticeDetailEn : MainNoticeDetailKo
)

const moveToSupera = () => {
  window.open('https://www.superalink.com/en', '_blank')
}
const moveToChannelHome = () => {
  window.open('https://usimsa.channel.io/home', '_blank')
}
</script>

<style scoped lang="scss">
:deep(.sub-gnb-back-title) {
  height: 56px;
}
.verify-notice {
  padding-bottom: 100px;
}
</style>
